<template>
  <div class="CardPlant">
    <Splitter :left="5" :right="7">
      <Pic
        slot="left"
        :alt="plant.alt"
        class="image"
        :src="plant.image" />

      <div slot="right" class="body">
        <div class="label">
          <h3>{{ plant.label }}</h3>
        </div>
        <div class="text">
          {{ plant.text }}
        </div>
      </div>
    </Splitter>
  </div>
</template>

<script>
import Splitter from 'views/components/Splitter'

export default {
  components: { Splitter },

  props: {
    plant: Object,
  },
}
</script>

<style lang="scss">
.CardPlant {
  background-color: $white;
  margin: 2rem 0;

  img {
    height: auto;
    width: 100%;
  }

  .Splitter-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
    max-width: unset;
    padding: 2rem;
    width: 100%;
    @include lg {
      padding: 4rem 4rem 3rem;
    }

    .label {
      padding-bottom: 1rem;
    }

    .text {
      color: $grey;
    }
  }
}
</style>
